<catalog-list
  [selectMode]="true"
  (onCatSelected)="onCatSelected()"
  [limitProducts]="[lc.product]"
></catalog-list>
